/**
 * @generated SignedSource<<c643868cbf008913b96296e5b9216c5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonSidePanelNotes_user$data = {
  readonly id: number;
  readonly " $fragmentType": "PersonSidePanelNotes_user";
};
export type PersonSidePanelNotes_user$key = {
  readonly " $data"?: PersonSidePanelNotes_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanelNotes_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonSidePanelNotes_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "d76b3a9c2bb57e150525317b058a6564";

export default node;
